import { Canvas } from "@react-three/fiber"
import { Suspense, useRef, useEffect } from "react"
import StaticGeometry, { SemiStaticGeometry } from "./Loaders/StaticGeometry"
import InteractiveBuilding from "./Loaders/InteractiveBuilding"
import FilteringUI from "./UI/FilteringUI"
import Enviro from "./Loaders/Enviro"
import CameraControls from "./Components/CameraControls"
import CoordinatesBroadcaster from "./State/CoordinatesBroadcaster"
import ApartmentCard from "./Components/ApartmentCard"
import InstanceGeometry from "./Loaders/InstanceGeometry"
import PoiMarkers from "./Loaders/PoiMarkers"
import FavouriteUI from "./UI/FavouriteUI"
import { useStore } from "./State/Store"
import POI from "./Components/POI"
import { useFrame } from "@react-three/fiber"
import { Vector3 } from "three"
import { useCallback } from "react"
import { Spherical, Math } from "three"
import CloudsLoader from "./Loaders/CloudsLoader"
import { ApartmentFinderHolder } from "./ApartmentFinder.style"
import "./ApartmentFinder.css"

function Loader() {
  const setLoaded = useStore(state => state.setLoaded)
  const setCurrentCameraPositionID = useStore(
    state => state.setCurrentCameraPositionID
  )
  useEffect(() => {
    setCurrentCameraPositionID("init")
    console.log("loading")
    return () => {
      setLoaded(true)
    }
  }, [])
  return null
}

function Compass({ test }) {
  var dir = new Vector3()
  var sph = new Spherical()

  useFrame(({ camera }) => {
    camera.getWorldDirection(dir)
    sph.setFromVector3(dir)
    test(sph.setFromVector3(dir))
  })

  return null
}

export default function ApartmentFinder({
  staticGeometryID,
  semiStaticGeometryID,
  interactiveBuildingID,
  hdriFile
}) {
  const apartments = useStore(state => state.apartments)

  const compassRef = useRef()

  const test = useCallback(v => {
    compassRef.current.style.transform = `rotate(${
      Math.radToDeg(v.theta) - 240
    }deg)`
  })

  return (
    <ApartmentFinderHolder>
      {apartments && <ApartmentCard />}

      {apartments && <FavouriteUI />}
      {apartments && process.env.REACT_APP_ROLE !== "recipient" && (
        <FilteringUI />
      )}
      {apartments && <POI />}

      <img
        ref={compassRef}
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          margin: "1.5%",
          pointerEvents: "initial",
          right: 0,
          zIndex: 3000000
        }}
        src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/compass.svg`}
        width={60}
        height={60}
        alt=""
        title="Menu"
      ></img>
      {/* </div> */}

      <Canvas
        shadows
        gl={{
          antialias: true
        }}
        camera={{
          position: [0, 10000, 0],
          fov: 60,
          near: 100,
          far: 15000000
        }}
        // camera={camera}
        colorManagement={true}
        // dpr={2}
        dpr={1}
      >
        <Suspense fallback={<Loader />}>
          <CloudsLoader />
          <pointLight
            position={[10, 10000, 10]}
            intensity={0.8}
            color={"white"}
          />
          <pointLight
            position={[100000, 10000, 10000]}
            intensity={0.5}
            color={"white"}
          />
          <ambientLight intensity={0.5} />
          {/* <BirdsLoader /> */}
          <Enviro hdriFile={hdriFile} />
          <PoiMarkers />
          {/* <Stats
            style={{ userSelect: "none" }}
            showPanel={0}
            className="stats"
          /> */}
          <InstanceGeometry />

          <StaticGeometry geometryID={staticGeometryID} />
          <SemiStaticGeometry geometryID={semiStaticGeometryID} />
          <Compass test={test} />
          {apartments && (
            <InteractiveBuilding
              buildingID={interactiveBuildingID}
              // clickedMesh={clickedMesh}
            />
          )}
        </Suspense>
        {/* <Profiler /> */}

        <CameraControls />
        {process.env.REACT_APP_MARKETING_SUITE && <CoordinatesBroadcaster />}
      </Canvas>
    </ApartmentFinderHolder>
  )
}
